import React, { FC } from 'react';
import { Box, Divider } from '@material-ui/core';
import CashFinanceGroup from '../cashFinanceGroup/CashFinanceGroup';
import PriceSectionContainer from '../PriceSection/PriceSectionContainer';
import Grid from '@material-ui/core/Grid';
import useIsMobile from '../../../../../common/react/useIsMobile';
import financeProductGridElementStyles from './financeProductGridElementStyles';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import clsx from 'clsx';

export interface IFinanceProductGridElementProps {
  setIsFinCalcSpcModalOpen: (value: boolean) => void;
  isFinCalcSpcModalOpen: boolean;
  isCash: boolean;
  isMultiCurrency: boolean;
  isCtaDisabled: boolean;
}

const FinanceProductGridElement: FC<IFinanceProductGridElementProps> = ({
  setIsFinCalcSpcModalOpen,
  isFinCalcSpcModalOpen,
  isCash,
  isMultiCurrency,
  isCtaDisabled,
}) => {
  const style = financeProductGridElementStyles();
  const {
    platformConfig: { isFinanceEnabled },
  } = usePlatformConfig();
  const isMobile = useIsMobile();

  return (
    <Grid item={true} lg={8} sm={12} className={style.gridElement}>
      <Box className={clsx(style.container, { [style.multiCurrency]: isMobile && isMultiCurrency })}>
        {isFinanceEnabled && (
          <CashFinanceGroup
            setIsFinCalcSpcModalOpen={setIsFinCalcSpcModalOpen}
            isCash={isCash}
            isMultiCurrency={isMultiCurrency}
            isCtaDisabled={isCtaDisabled}
          />
        )}
        <Box className={style.priceDisplayElement}>
          {isMobile && !isCash && !isMultiCurrency && (
            <Divider
              orientation="vertical"
              className={style.mobileDivider}
              data-test={'finance_values:mobile_divider'}
            />
          )}
          <PriceSectionContainer
            setIsFinCalcSpcModalOpen={setIsFinCalcSpcModalOpen}
            isFinCalcSpcModalOpen={isFinCalcSpcModalOpen}
          />
          <Divider orientation="vertical" className={style.divider} />
        </Box>
      </Box>
    </Grid>
  );
};

export default FinanceProductGridElement;
